query AutocompletePromocodeCampaigns($input: String, $value: [ID!]) {
  autocompletePromocodeCampaigns(input: $input, value: $value) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}
